<section class="modal d-flex direction-column justify-space-between">
  <form [formGroup]="form">
    <div class="modal-header header">
      <div class="header-title title pb-16">
        <span class="title-email" mat-dialog-title>Configurar E-mail</span>
      </div>
      <ng-container *ngIf="data?.type === DialogEmailTypeEnum.Invoice">
        <app-c-select
          class="header-select"
          width="335px"
          height="42px"
          placeholder="Selecione o banco"
          formControlName="bank"
          [readonly]="false"
          [data]="banks"
        ></app-c-select>
      </ng-container>
    </div>
    <div class="modal-body body pt-20 pb-20">
      <div class="body-subject">
        <!-- Editor de uma linha em vez de input: é o que permite as variáveis
             serem widgets atômicos, iguais às do corpo. -->
        <app-c-rich-text
          formControlName="Subject"
          [singleLine]="true"
          [allowInsertVariables]="!data?.infos?.TemplateId"
          [templateVariables]="templateVariables"
          [templateVariablesLength]="templateVariables.length + 1"
        ></app-c-rich-text>
      </div>

      <div class="body-email pt-15">
        <app-c-rich-text
          formControlName="Template"
          [allowInsertVariables]="!data?.infos?.TemplateId"
          [blockPreview]="blockPreview"
          [templateVariables]="templateVariables"
          [templateVariablesLength]="templateVariables.length + 1"
        ></app-c-rich-text>
      </div>
    </div>
    <div
      class="modal-footer footer d-flex justify-space-between"
    >
      <button class="footer-back ui-btn ui-btn--secondary" mat-dialog-close>Voltar</button>
      <button class="footer-save ui-btn ui-btn--primary" (click)="saveConfig()">
        Salvar Configurações
      </button>
    </div>
  </form>
</section>
